// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__2lNv9","additionalInfo":"AgreementModal_additionalInfo__38JDV"};